<template>
  <span>
    Incorrect email or password.<br>Try again or
    <button
      id="resend"
      type="button"
    >reset your password</button>.
  </span>
</template>

<style lang="less" scoped>
#resend {
  cursor: pointer;
}
</style>
